import React from 'react'

interface MultiLineDTProps {
  size?: number | string;
  color?: string;
  className?: string;
  onClick?: () => void;
}

const MultiLineDT: React.FC<MultiLineDTProps> = ({
  size = 20,
  color = '#003366',
  className,
  onClick,
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    onClick={onClick}
  >
    <path d="M11.667 3.75H17.5003" stroke={color} strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M11.667 7.91602H17.5003" stroke={color} strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M2.5 12.084H17.5" stroke={color} strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M2.5 16.25H17.5" stroke={color} strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M7.91699 7.02565V4.64232C7.91699 3.70898 7.54199 3.33398 6.60033 3.33398H4.22533C3.29199 3.33398 2.91699 3.70898 2.91699 4.64232V7.01732C2.91699 7.95898 3.29199 8.33398 4.22533 8.33398H6.60033C7.54199 8.33398 7.91699 7.95898 7.91699 7.02565Z" stroke={color} strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
)

export default MultiLineDT
